import styled, { css } from 'styled-components'
import { assetPrefix } from 'config/env_config'
import { MEDIA } from 'utils/constants'
import { Button as StyledButton } from 'components/button/v2'
import { PET_TYPES } from 'cobasi-utils/constants'

const closeIcon = `${assetPrefix}/static/icons/times.svg`
const catImage = `${assetPrefix}/static/icons/cat-default-icon.svg`
const dogImage = `${assetPrefix}/static/icons/dog-default-icon.svg`
const piggyIndian = `${assetPrefix}/static/icons/ginea-pig-default-icon.svg`
const rabbit = `${assetPrefix}/static/icons/rabbit-default-icon.svg`
const petImageType = {
  [PET_TYPES.CAT]: catImage,
  [PET_TYPES.DOG]: dogImage,
  [PET_TYPES.FERRET]: piggyIndian,
  [PET_TYPES.RABBIT]: rabbit,
  [PET_TYPES.PIGGY_INDIAN]: piggyIndian
}

export const Container = styled.div`
    ${({ show }) => css`
        position: fixed;
        top: 0;
        right: 0;
        width: 100vw;
        height: 100vh;
        z-index: ${show ? 999 : -1};
        opacity: ${show ? 1 : 0};
        visibility: ${show ? 'visible' : 'hidden'};
        transition: 0.3s;

        @media screen and ${MEDIA.MOBILE} {
            overflow: auto;
        }
    `}
`

export const Backdrop = styled.div`
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    z-index: 1;
    background-color: rgba(0,0,0,0.2);
`

export const ModalContent = styled.div`
    background-color: var(--the-white);
    border-radius: 2.4rem;

    overflow: hidden;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-size: cover;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 16px;

    @media screen and ${MEDIA.MOBILE} {
        border-radius: 2.4rem;
        max-width: 320px;
        width: 100%;
    }
`

export const ModalHeader = styled.div`
    width: 100%;

    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 10px;

    @media screen and ${MEDIA.MOBILE} {
        background-size: 80%;
    }
`

export const Img = styled.div`
    &::before {
      content: '';
      display: block;
      width: 232px;
      height: 232px;
      background-image: url(${({ petType }) => petImageType[petType]});
      background-size: contain;
    }
`

export const ModalBody = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    justify-content: center;
    position: relative;
`

export const ModalClose = styled.div`
    cursor: pointer;
    width: 24px;
    height: 24px;

    background-image: url('${closeIcon}');
    background-size: cover;
    background-repeat: no-repeat;
`

export const Title = styled.h1`
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    width: 100%;
    margin-top: 16px;
    margin-bottom: 8px;
    word-break: break-word;
`

export const Paragraph = styled.p`
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    margin-bottom: 16px;
    word-break: break-word;
    color: var(--gray-5);
`

export const Actions = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    row-gap: 16px;

    @media screen and ${MEDIA.MOBILE} {
        width: 100%;
    }
`

export const Button = styled(StyledButton)`
`
